const Tip = ({ text }) => {
    return (
    <p className='font-body text-darkerGreen bg-opacity-50'>{text}</p>
    )
}

export default Tip